import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ palette }) => ({
  negativeValue: {
    color: palette.error.main,
    fontWeight: 600,
  }
}));

export default useStyles;
